import BossModel from "@/models/BossModel";
import Dossier from '@/models/Dossier/Dossier'
import User from "@/models/User/User";

export default class Complaint extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'dossier/complaint';

    /**
     *
     * @type {string}
     */
    static entity = 'dossierComplaints';

    static fields() {
        return {
            id: this.number(null).nullable(),
            dossier_id: this.number(null).nullable(),
            created_by_user_id: this.attr(null),
            resolved_by_user_id: this.attr(null).nullable(),
            department_cid: this.attr(null).nullable(),
            initiated_at: this.attr(null),
            resolved_at: this.attr(null).nullable(),
            description: this.attr(null),
            solution: this.attr(null).nullable(),
            is_extensive: this.boolean(false),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            createdByUser: this.belongsTo(User, 'user_id'),
            resolvedByUser: this.belongsTo(User, 'user_id'),
            dossier: this.belongsTo(Dossier, 'dossier_id'),
        }
    }
}
